// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W6wW2","col":"styles_col__3qHbc"};